<template>
    <div class="h-p-100">
        <tool-bar
                :title="payStatus === 1 ? 'Payment successful':payStatus === 2 ? 'Payment Fail':'In Payment'"></tool-bar>
        <div class="h-101 flex-v flex-h-center flex-v-center" style="margin-top: 70%;margin-bottom: 30%">
            <img class="w-60 h-60" :src="require(payStatus === 1 ? '../../assets/icon_spay.png' :
            payStatus === 2 ? '../../assets/icon_fpay.png':'../../assets/icon_inpay.png')">
            <div class="font-21 font-bold color-14171B margin-t-30">
                {{payStatus === 1 ? 'Thank you.' : payStatus === 2 ? 'Payment failed' : 'Please wait'}}
            </div>

            <div class="font-16 font-bold color-888F99 margin-t-16">
                {{payStatus === 1 ? 'You have paid successfully.' :
                payStatus === 2 ? 'The balance of bank card is insufficient.' :
                'Payment verification in progress.'}}
            </div>
        </div>
        <div class="bg-FFFFFF h-71 flex-v flex-h-center font-bold"
             style="position: fixed;bottom: 0;width: 100%; margin-bottom: 10px;"
             v-show="payStatus === 1 || payStatus ===2 ">
            <div class="padding-h-15">
                <van-button class="w-p-100"
                            style="height: 55px;border-radius: 8px;font-size: 19px;"
                            :color="payStatus === 1 ?'linear-gradient(to right,#1093FF, #69BBFF)':
                            'linear-gradient(to right,#EE4747,#F78B8B)'"
                            @click="paySuccess()"
                            block>
                    {{payStatus === 1 ? 'Got it' : 'Repayments'}}
                </van-button>
            </div>
        </div>

    </div>
</template>

<script>
    export default {
        name: "pay_result",
        data() {
            return {
                //0、进行中 1、成功 2、失败
                payStatus: 0,
                id: '',
                // 1、绑卡结果 2、银行卡支付结果
                type: 1
            }
        },
        mounted() {
            let id = this.$route.query.id
            let type = this.$route.query.type
            if (id && type) {
                if (type == 1) {
                    this.getBindCardResult(id)
                } else if (type == 2) {
                    this.getPayResult(id)
                }
            }
        },
        methods: {
            getBindCardResult(id) {
                this.$request.getBindCardResult(id)
                    .then((res) => {
                        if (res.status === 2) {
                            this.payStatus = 1;
                        } else {
                            this.payStatus = 0;
                            let self = this
                            setTimeout(() => {
                                self.getBindCardResult(self.id)
                            }, 2000)
                        }
                    })
                    .catch(() => {
                    })
            },
            getPayResult(id) {
                this.$request.getPayResult(id)
                    .then((res) => {
                        if (res.status === 7) {
                            this.payStatus = 1;
                        } else {
                            this.payStatus = 0;
                            let self = this
                            setTimeout(() => {
                                self.getPayResult(self.id)
                            }, 2000)
                        }
                    })
                    .catch(() => {
                    })
            },
            paySuccess() {
                this.$router.go(-1)
            }
        }
    }
</script>

<style scoped>

</style>